export default "__VITE_ASSET__C1_3X76Z__"